import React, { useEffect } from 'react';
import { EMPTY } from 'utils/atomUtils';
import BookingSelectInput from './BookingSelectInput';
import StartTimeIcon from './StartTimeIcon';
import { useAnalytics as trackAvailableTimes } from './hooks/useAnalytics';
import { useTimeOptions } from './hooks/useTimeOptions';
import { useTimePickerData } from './hooks/useTimePickerData';
import { TimePickerProps } from './types';
import { getErrorMessage, TimeNotice } from './utils';

// Main component
const TimePicker: React.FC<TimePickerProps> = ({
  onChange = () => {},
  modalVersion = false,
  editable = true,
  calendar,
  error = null,
  useDuration = false,
  isOwner = false,
  isMessageOwner = false,
}) => {
  const data = useTimePickerData();

  const options = useTimeOptions({ calendar, useDuration }, data);

  const errorToShow = getErrorMessage(options, calendar, error);

  const isDisabled = !editable || options.length === 0;

  trackAvailableTimes(data, options, isMessageOwner);

  // handle the case when tripTime is set and not available in options
  useEffect(() => {
    if (data.tripTime) {
      // Handle both object and string cases
      const currentValue = typeof data.tripTime === 'object' ? data.tripTime.value : data.tripTime;

      // Check if the current tripTime value exists in options
      const isTimeAvailable = options.some((option) => option.value === currentValue);

      if (!isTimeAvailable) {
        data.setTripTime(EMPTY);
      }
    }
  }, [options, data.tripTime, data.setTripTime]);

  return (
    <div data-testid="pdp-booking-widget-time-picker-container">
      <BookingSelectInput
        name="TimePicker"
        object="start_time_picker"
        error={errorToShow}
        modalVersion={modalVersion}
        icon={<StartTimeIcon />}
        options={options}
        defaultValue={data.tripTime}
        onChange={onChange}
        setter={data.setTripTime}
        title="Start time"
        isDisabled={isDisabled}
        isOwner={isOwner}
        notice={<TimeNotice />}
        isMessageOwner={isMessageOwner}
      />
    </div>
  );
};

export default TimePicker;
